import React from 'react';
import { Heart } from 'lucide-react';

const CareersSection = () => {
  return (
    <section id="careers" className="py-16 md:py-24 bg-gradient-to-b from-violet-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Join Our Nurse Team
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            We're building a team of compassionate, experienced nurses who want to make a difference in families' lives.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg border border-violet-100">
          <div className="flex items-center justify-center mb-6">
            <Heart className="w-8 h-8 text-violet-600 mr-3" />
            <h3 className="text-xl font-semibold text-slate-800">
              We're Not Hiring Right Now
            </h3>
          </div>
          
          <p className="text-base text-slate-600 mb-6">
            We're growing and expect to have opportunities for talented nurses soon. 
            Check back here for updates on open positions.
          </p>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-slate-500">
            NurseBloc is an equal opportunity employer. We celebrate diversity and are committed to creating an inclusive environment for all employees.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CareersSection;
